export default __webpack_public_path__ + "static/media/242.96e013fc.jpg";